var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"machine-type-container"},[_c('machine-type-list',{ref:"machineTypeListRef"}),_c('machine-type-footer',{attrs:{"itemsRef":_vm.machineTypeListRefState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }